import "./AttendanceAndCancellationPolicyComponent.scss";
import React, {useEffect, useState} from "react";
import {ImageConfig} from "../../../constants";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {CommonService} from "../../../shared/services";
import {getSystemSettingDetails} from "../../../store/actions/user.action";


interface AttendanceAndCancellationPolicyComponentProps {
    setIsAttendanceModalOpen?: any;
    isNoticeOfPrivacyPolicyNeeded?: boolean;
}


const AttendanceAndCancellationPolicyComponent = (props: AttendanceAndCancellationPolicyComponentProps) => {

    const {setIsAttendanceModalOpen, isNoticeOfPrivacyPolicyNeeded} = props;
    const {systemSettingsDetails} = useSelector((state: IRootReducerState) => state.user);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSystemSettingDetails())
    }, [dispatch]);

    const policies = [

        ...(isNoticeOfPrivacyPolicyNeeded
                ? [{
                    id: "noticeOfPrivacyPolicyNeeded",
                    title: "Our Notice of Privacy Practices",
                    sideTitle: "Notice of Privacy Practices",
                    icon: <ImageConfig.PrivacyPolicyIcon height={40} width={40}/>,
                    content: `
                  <p>At <strong>Kinergy Sports Medicine and Performance</strong>, we respect and are committed to protecting your privacy and ensuring that your personal health information is handled with the utmost care and confidentiality. As part of this commitment, the collection, use, and disclosure of certain personal and health information about you are governed by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and applicable state law. Any information you provide to us that qualifies as Protected Health Information (PHI), as defined by HIPAA, will be handled according to HIPAA guidelines and relevant state regulations.</p>
                  <br/>
                  <p>PHI refers to individually identifiable health information related to your past, present, or future physical or mental health conditions. This <b>Notice of Privacy Practices</b> explains how your PHI may be used and disclosed, as well as how you can access and control this information.
                    </p><br/>
                    <p><b>1. Uses and Disclosures of Health Information</b></p><br/>
                    <p>We may use and disclose your health information for the following purposes:</p><br/>
                    <ul class="mrg-left-20">
                    <li><b>Treatment:</b> We may use your health information to provide, coordinate, or manage any of your cases. This may involve sharing your information with other healthcare providers, such as physicians or specialists, involved in your care.</li>
                    <li><b>Payment:</b> We may use or disclose your information to bill and collect payment for the services provided to you. This may include sending your health information to insurance companies or other third-party payers.
                </li>
                <li>
                <b>Healthcare Operations:</b> We may use your information for administrative purposes, such as quality control, improvement of services, and training of staff.
                </li>
                <li><b>Appointment Reminders:</b> We may use your health information to contact you for appointment reminders or follow-up care.</li>
                 <li><b>Legal Requirements:</b> We may disclose your health information when required by law, such as in response to subpoenas, court orders, or government investigations.
                </li> 
                 </ul><br/>
                 <p><b>2. Your Rights Regarding Health Information</b></p><br/>
                
                 <p>You have the following rights concerning your health information:</p><br/>
                 <ul class="mrg-left-20">
                 <li><b>Right to Access:</b> You have the right to request and inspect copies of your medical records. We may charge a fee for the cost of copying and mailing.</li>
                <li><b>Right to Correct Information:</b> If you believe any information in your medical record is incorrect or incomplete, you have the right to request that it be corrected.</li>
               <li><b>Right to Request Restrictions:</b> You have the right to request restrictions on how your health information is used or disclosed. While we are not required to agree to all requests, we will consider them.</li>
               <li><b>Right to Confidential Communications:</b> You have the right to request that we communicate with you about your health information in a certain way or at a certain location (e.g., by phone instead of mail).</li>
                <li><b>Right to an Accounting of Disclosures:</b> You have the right to request a list of disclosures of your health information made by us for purposes other than treatment, payment, and healthcare operations.</li>
                <li><b>Right to a Copy of This Notice:</b> You may request a copy of this Notice of Privacy Practices at any time, even if you have already received one.</li>
                </ul><br/>
                <p><b>3. How We Protect Your Information</b></p><br/>
                <p>We are committed to securing your personal health information. We use a variety of security measures, such as encryption and secure access protocols, to protect your information from unauthorized access or disclosure. We also limit access to your health information to those employees and partners who need it to perform their job duties.
                </p><br/>
                <p><b>4. Changes to This Notice</b></p><br/>
                <p>We may change the terms of this Notice at any time. Any changes will be effective immediately upon updating this notice in our clinic and on our website. You will also receive a copy of the revised notice through your Client Portal.</p>
               <br/> <p><b>5. Filing a Complaint</b></p><br/>
                <p>If you believe that your privacy rights have been violated, you may file a complaint with us or with the U.S. Department of Health and Human Services. We will not retaliate against you for filing a complaint.</p>
                    <br/>
                    <p>To file a complaint or if you have questions about this Notice, please contact:</p>
               <br><p><b>Terrill Lobo</b></p>
                <p>Owner, Kinergy Sports Medicine and Performance</p>
<p>Phone: ${CommonService.formatPhoneNumber(systemSettingsDetails?.other_settings?.admin_phone) || 'N/A'}</p>
`,
                }]
                : []
        ),
        {
            id: "attendance",
            title: "Our Attendance/Cancellation Policy",
            sideTitle: "Attendance/Cancellation Policy",
            icon: <ImageConfig.AttendancePolicyIcon height={40} width={40}/>,
            content: `
      <p>At <strong>Kinergy Sports Medicine and Performance</strong>, we are committed to providing the highest quality of to help you achieve your health and wellness goals. To ensure that we can deliver timely and effective care to all our clients, we ask for your cooperation in adhering to our appointment and attendance guidelines. We appreciate your understanding and adherence to the following policy:</p>
      <br/>
      <ul>
        <li>We strive to accommodate your schedule by offering flexible appointment times. To help us maintain a smooth and efficient schedule, we ask that you arrive five (5) minutes early for all scheduled appointments.</li>
        <li>If you arrive more than fifteen (15) minutes late for a scheduled appointment, we may need to reschedule or adjust the length of your appointment. We are unable to extend appointment times to make up for the time you have missed, and the full appointment fee will apply.</li>
        <li>If you arrive more than thirty (30) minutes late for an appointment without prior notification, the appointment will be canceled, and you will be charged the full appointment fee.</li>
        <li><strong>24-Hour Notice:</strong>  Cancellation or rescheduling of your appointment must be made at least <b>twenty-four (24) hours</b> in advance to help us accommodate other clients. If you cancel with less than 24 hours’ notice, the full appointment fee will be charged.
        <br/><br/><ul>
   
                 <li class="mrg-left-30">You can cancel or reschedule your appointment by calling our clinic at ${CommonService.formatPhoneNumber(systemSettingsDetails?.other_settings?.admin_phone) || 'N/A'}. Voicemails or messages left after business hours may not be processed in time, so please cancel in advance whenever possible. </li>
    </ul>
   
 
    </li>
    <br/>
        <li><strong>No Show:</strong> If you do not show up for a scheduled appointment, you will be charged the full session fee.</li>
        <li>If you miss three (3) consecutive appointments without notice, we may require a deposit for future appointments or we may cancel all future scheduled appointments.
</li>
        <li>All cancellations, late arrivals, and absences will be documented in your client record. When applicable, we will report absences to your physician, insurance provider, or third-party payer.</li>
        <li>Clients are responsible for the fees associated with missed appointments, late arrivals, or cancellations within the 24-hour window. These fees are not covered by insurance or third-party payers and will be billed directly to you. </li>
        <li>We understand that unexpected emergencies and illness may occur. Please notify us as soon as possible if you are unable to attend an appointment due to an emergency. We will consider these situations on a case-by-case basis and may waive the cancellation fee at our discretion. </li>
      <li>If you repeatedly miss appointments or fail to comply with our attendance and cancellation policy, we may limit or discontinue services. </li>
      </ul>
      <p>We appreciate your understanding and cooperation in following these guidelines. Our goal is to provide the best care possible, and by adhering to this policy, you help us ensure that all clients receive the care they need in a timely manner. </p>
<br/>
      <p>Thank you for choosing <strong>Kinergy Sports Medicine and Performance</strong> for your healthcare needs. We look forward to working with you on your journey to better health.</p>
    `,
        },
    ];

    const [selectedPolicy, setSelectedPolicy] = useState<any>(policies[0]);

    return (
        <div className="policy-container">
            {/* Left Side: Policy List */}
            <div className="policy-list">
                <h2 className="policy-header">
                    Know our <br/> policies better
                </h2>
                <p>Please select a policy from the list.</p>
                {policies.map((policy) => (
                    <div
                        key={policy?.id}
                        className={`policy-item ${
                            selectedPolicy?.id === policy?.id ? "selected" : ""
                        }`}
                        onClick={() => setSelectedPolicy(policy)}
                    >
                        <span className="policy-icon">{policy?.icon}</span>
                        {policy?.sideTitle} <span className={'pdd-top-5 pdd-left-10'}>
                            {selectedPolicy?.id === policy?.id ? (
                                <ImageConfig.CircleRightArrowFilled/>
                            ) : (
                                <ImageConfig.CircularFilledIcon/>
                            )}
                        </span>
                    </div>
                ))}
            </div>

            {/* Right Side: Policy Content */}
            <div className="policy-content">
                <span className="close-icon"
                      onClick={() => setIsAttendanceModalOpen(false)}><ImageConfig.CloseIcon/></span>
                <div className="policy-content-header">{selectedPolicy?.title}</div>
                <div className={'policy-content-text'} dangerouslySetInnerHTML={{__html: selectedPolicy?.content}}/>
            </div>
        </div>
    );
};

export default AttendanceAndCancellationPolicyComponent;
